
function Bill() {
    /// <summary>
    /// This object provides js functions for the Widget.Meta.Price.Bill.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 8.9.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 16.10.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

    this.mtid = -1; //meta type id
    this.mbid = -1; // meta bill id
    this.billList = null;
}

Bill.prototype = new vcTemplate();

Bill.prototype.init = function () {
    /// <summary>
    /// This function inits the click handler. 
    /// </summary>
    var me = this;
   
    try {
        if (me.error) {
            return false;
        }
     
        me.showInfo("", "", false);
        me.showDevIcon("beta");
        //show all bills for the meta type
        me.visual.find("#ddlPriceMetaTypes").off("change").on("change", function() { me.getBills();});
      
        //add new bill
        me.visual.find("#divBtnNewBill").button().off("click").on("click", function () { me.editBill(-1) });
        //show items for selected bill
        me.visual.find("#divBillList").off("click", ".vc-list-item").on("click", ".vc-list-item", function () { me.showBillItems($(this)) });
        //edit bill
        me.visual.find("#divBillList").off("click", ".fa-edit").on("click", ".fa-edit", function (e) {
            me.editBill(parseInt($(this).data("id"),10));
            e.stopPropagation();
        });
        //delete bill
        me.visual.find("#divBillList").off("click", ".fa-times").on("click", ".fa-times", function (e) {
            me.delBillDialog(parseInt($(this).data("id"), 10),true);
            e.stopPropagation();
        });
        //add new item for current bill
        me.visual.find("#divBtnNewItem").button().off("click").on("click", function () { me.editBillItem(-1, parseInt(me.visual.find("#ddlItemType").val(), 10)) });
        //edit selected bill item
        me.visual.find("#divItemList").off("click", ".vc-list-item").on("click", ".vc-list-item", function (e) {
            me.editBillItem(parseInt($(this).data("id"), 10), parseInt($(this).data("type"), 10));
            e.stopPropagation();
        });
        //delete selected bill item
        me.visual.find("#divItemList").off("click", ".fa-times").on("click", ".fa-times", function (e) {
            me.delBillDialog(parseInt($(this).data("id"), 10), false);
            e.stopPropagation();
        });

        //handle back button (which is generated in addFormEditHeader!!!)
        me.visual.find("#divEdit").off("click", "#btnBack").on("click", "#btnBack", function () { me.back(); });

        me.resetSizes();

        //show initial bill list
        me.getBills();

    return true;
    } catch (ex) { me.writeError('init', ex); return false }

}


Bill.prototype.resetSizes = function () {
    /// <summary>
    ///  This function adopts sizes of different div.
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        //set new height of the bill list entries (left)
        me.visual.find("#divBillList .entries").height(parseInt(me.visual.find("#divBillList").height() - me.visual.find("#divBillList .header").height(), 10) - 35);

        //reset the width of the item list (right)
        me.visual.find("#divItemList").width(parseInt(me.visual.width() - me.visual.find("#divBillList").width(), 10) - 40);
        //reset the with of the edit form
        me.visual.find("#divEdit").width(me.visual.find("#divItemList").width());
        //reset the with of the save button
        me.visual.find("#divSave").width(parseInt(me.visual.find("#divItemList").width() - me.visual.find("#divCalculation").width(), 10) - 40);

        return true;
    } catch (ex) { me.writeError('resetSizes', ex); return false }

}

Bill.prototype.addFormEditHeader = function (type) {
    /// <summary>
    ///  This function adds a header and content div for the edit form.<br/>
    ///  In the header exists a back button with the current data type set.
    /// </summary>
    var me = this;
    var sTmp;
    try {
        if (me.error) {
            return false;
        }
        sTmp = "<div id='divEditHeader'><div id='btnBack'>" + me.resources.back + "</div></div>";
        sTmp += "<div id='divEditContent' ></div>";
        me.visual.find("#divEdit").html(sTmp);
        me.visual.find("#divEdit #btnBack").data("type", type).button();
        return true;
    } catch (ex) { me.writeError('addFormEditHeader', ex); return false }

}

Bill.prototype.back = function () {
    /// <summary>
    ///  This function handles the back button based on the set data type.
    /// </summary>
    var me = this;

    var type;
    try {
        if (me.error) {
            return false;
        }
        type = parseInt(me.visual.find("#divEdit #btnBack").data("type"), 10);
        if (type === 0) {
            me.getBills();
        }
        if (type === 1) {
            me.showBillItems(me.visual.find("#divBillList .vc-list-item.active"));
        }
        return true;
    } catch (ex) { me.writeError('back', ex); return false }

}

Bill.prototype.getBills = function () {
    /// <summary>
    ///  This function fetches all bills for the given mtid and fills the bill list.
    /// </summary>
    var me = this;

    try {
        if (me.error) {
            return false;
        }
        
       //show the edit form 
        me.visual.find("#divItemList").hide(0);
        me.visual.find("#divEdit").show();
        me.visual.find("#divEdit").html("<div class='note'>" + me.resources.noBillTemplateSelected + '</div>');
        //set the mtid
        me.mtid = me.visual.find("#ddlPriceMetaTypes").val();
       
        me.visual.find("#divBillList .entries").html(me.vcC.getLoadingIcon());
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'type': 1,'mtid': me.mtid}),
       function (result) {
           if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }
           if (result === false) { me.showMessage(me.resources.err_loadData, true); return false; }
           if (result.rows === null) {
               me.visual.find("#divBillList .entries").html("<div class='note'>" + me.resources.noEntriesExist + "</div>");
               return true;
           }
           //save the current bill list
           me.billList = result;
           //generate the bill list
           me.visual.find("#divBillList .entries").html(me.generateBillList(me.billList));
           return true;
       });
        return true;
    } catch (ex) { me.writeError('getBills', ex); return false }

}

Bill.prototype.generateBillList = function (bills) {
    /// <summary>
    ///  This function generates the html for the bill list based on the received data table. 
    /// </summary>
    var me = this;
    var sTmp = "";
    try {
        if (me.error) {
            return "";
        }

       for (var i = 0; i <= bills.rows.length - 1; i++) {
           sTmp += "<div data-id='" + bills.rows[i].id + "' class='vc-list-item ui-widget-content'><b>" + bills.rows[i].name + "</b>" +
           "<br/>" + $.datepicker.formatDate('dd.mm.yy', bills.rows[i].startdate)  +
           "<br/>" + bills.rows[i].signal +
           "<i data-id='" + bills.rows[i].id + "' class='fa fa-edit icon-color-ok' ></i><i data-id='" + bills.rows[i].id + "' class='fa fa-times icon-color-error' ></i></div>";
       } 

        return sTmp;
    } catch (ex) { me.writeError('generateBillList', ex); return "" }

}

Bill.prototype.editBill = function (id) {
    /// <summary>
    ///  This function shows the edit form for one single bill.
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.mbid = id;
        me.visual.find("#divBillList .vc-list-item").removeClass("active");
        me.visual.find("#divItemList").hide(0);
        //adds the sub structure of the edit form
        me.addFormEditHeader(0);
        me.visual.find("#divEdit").show();
        me.vcVisual.addVisualBaseByName("divEdit", 'VISUAL_FORM_BILL', 'Content', getCurrentTimestamp(), parseInt($("#divEditContent").height(), 10), parseInt($("#divEditContent").width(), 10), JSON.stringify({'mbid':id, 'mtid':me.mtid}), '', 1);
        return true;
    } catch (ex) { me.writeError('editBill', ex); return false }

}

Bill.prototype.delBillDialog = function (id, bIsBill) {
    /// <summary>
    /// This function opens a modal dialog for deleting bills and bill items.<br/>
    /// </summary>
    var me = this;
    try {
        var dialog = $('<p>' + me.resources.shouldDataGetDeleted + '</p>').dialog({
            title: me.resources.dialogTitle, modal: true,
            buttons: {
                "Yes": function() {
                    if (bIsBill) {
                        me.delBill(id);
                    } else {
                        me.delBillItem(id);
                    }
                    dialog.dialog('close');
                    
                },
                "No": function () {
                    if (bIsBill) {
                        me.getBills();
                    }
                    dialog.dialog('close'); },
                "Cancel": function () { dialog.dialog('close'); return false; }
            },
            dialogClass: 'saveDialog'
        });
        // ReSharper disable InvalidValue
        $('.saveDialog .ui-button-text:contains(YES)').text(me.resources.yes);
        $('.saveDialog .ui-button-text:contains(NO)').text(me.resources.no);
        $('.saveDialog .ui-button-text:contains(CANCEL)').text(me.resources.cancel);
        // ReSharper restore InvalidValue
        return false;
    } catch (ex) { me.writeError('delBillDialog', ex); return false; }
};

Bill.prototype.delBill = function (id) {
    /// <summary>
    ///  This function deletes one single meta bill.
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        id = parseInt(id, 10);
         window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'type': 1, 'mbid': id }),
        function (result) {

            if (result === null) { me.showMessage(me.resources.err_saveData, true); return false; }
            if (result === false) { me.showMessage(me.resources.err_savedData, true); return false; }
            //refresh the bill list after deleting
            me.getBills();
            return true;
        });

        return true;
    } catch (ex) { me.writeError('delBill', ex); return false }

}

Bill.prototype.showBillItems = function (obj) {
    /// <summary>
    ///  This function shows a list of bill items based on the given meta bill
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        //set the given bill template as active
        me.visual.find("#divBillList .vc-list-item").removeClass("active");
        obj.addClass("active");

        me.visual.find("#divEdit").hide(0);
        me.visual.find("#divItemList").show();

        me.mbid = parseInt(obj.data("id"), 10);


        me.visual.find("#divItemList .entries").html(me.vcC.getLoadingIcon());
        //get the bill item list
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'type': 2, 'mbid': me.mbid }),
       function (result) {
           if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }
           if (result === false) { me.showMessage(me.resources.err_loadData, true); return false; }
           if (result.rows === null) {
               //if no bill item exists - add functionality for copying existing bill items from another template
               me.visual.find("#divItemList .entries").html("<div class='note'>" + me.resources.noEntriesExist + "</div>");
              me.addCopyBill();
               return true;
           }
           me.visual.find("#divItemList .entries").html(me.generateItemList(result));

           me.visual.find("#divItemList .vc-list-item").filter(":even").addClass("alt");
       
           return true;
       });

        return true;
    } catch (ex) { me.writeError('showBillItems', ex); return false }
}

Bill.prototype.addCopyBill = function () {
    /// <summary>
    ///  This function adds the text, dropdown and copy-button for copying the bill items from one bill to another
    /// </summary>
    var me = this;
    var sTmp = "";
    var i;
    var mbidSource;
    try {
        if (me.error) {
            return false;
        }

        if (me.billList.rows.length > 1) {
            me.visual.find("#divItemList .entries").append("<br/>" + me.resources.doYouWantToCopyBill);
            sTmp += "<select id='ddlCopy' class='ddl'>";
            for (i = 0; i <= me.billList.rows.length - 1; i++) {
                if (me.billList.rows[i].id !== me.mbid) {
                    sTmp += "<option value='" + me.billList.rows[i].id + "'>" + me.billList.rows[i].name + "</option>";
                }
            }
            sTmp += "</select>";
            sTmp += "<div id='btnCopy'>" + me.resources.copyEntries + "</div><br/>";
            me.visual.find("#divItemList .entries").append("<br/>" + sTmp);
            me.visual.find("#divItemList .entries #btnCopy").button().off("click").on("click", function () {
          
                mbidSource = parseInt(me.visual.find("#divItemList .entries #ddlCopy").val(), 10);
                window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'type': 3, 'mbid': me.mbid, 'mbidSource': mbidSource }),
               function (result) {
                   if (result === null) { me.showMessage(me.resources.err_saveData, true); return false; }
                   if (result === false) { me.showMessage(me.resources.err_savedData, true); return false; }
                   me.showBillItems(me.visual.find("#divBillList .vc-list-item.active"));
                   return true;
               });
            });
        }

        return sTmp;
    } catch (ex) { me.writeError('addCopyBill', ex); return false }
}

Bill.prototype.generateItemList = function (items) {
    /// <summary>
    ///  This function generates the html for the bill list based on the received data table. 
    /// </summary>
    var me = this;
    var sTmp = "";
    var i;
    try {
        if (me.error) {
            return "";
        }
        sTmp += "<div class='list'>";
        for (i = 0; i <= items.rows.length - 1; i++) {
            sTmp += "<div data-id='" + items.rows[i].id + "' data-type='" + items.rows[i].itemtypeid + "' class='vc-list-item'>";
            sTmp += "<div  class='col col1'>" + items.rows[i].itemtype + "</div>";
            sTmp += "<div class='col col2'>" + items.rows[i].name + "</div>";
            sTmp += "<div class='col col3'>";
            if (items.rows[i].signal !== null) {
                sTmp += items.rows[i].signal;
            } else {
                sTmp += "<br/>";
            }
            sTmp += "</div>";
            sTmp += "<div class='col col4'>" + Highcharts.numberFormat(items.rows[i].price, me.digits, ',', '.') + " * " + items.rows[i].factor + "</div>";
            sTmp += "<div class='col col5'>" + items.rows[i].unit + "</div>";
            sTmp += "<div class='colDel'><i data-id='" + items.rows[i].id + "' class='fa fa-times icon-color-error' ></i></div>";
            sTmp += "</div>";
            sTmp += "<div style='clear:both'></div>";
        }
        sTmp += "</div>";
        return sTmp;
    } catch (ex) { me.writeError('generateItemList', ex); return "" }

}

Bill.prototype.editBillItem = function (id, type) {
    /// <summary>
    ///  This function shows the edit form for one single bill item.
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
       
        me.visual.find("#divItemList").hide(0);
        me.addFormEditHeader(1);
        me.visual.find("#divEdit").show();
      
        me.vcVisual.addVisualBaseByName("divEdit", 'VISUAL_FORM_BILLITEMS', 'Content', getCurrentTimestamp(), parseInt($("#divEditContent").height(), 10), parseInt($("#divEditContent").width(), 10), JSON.stringify({ 'mbid': me.mbid,'ItemTypeID':type, 'ItemId': id }), '', 1);
        return true;
    } catch (ex) { me.writeError('editBillItem', ex); return false }

}

Bill.prototype.delBillItem = function (id) {
    /// <summary>
    ///  This function deletes one single meta bill item.
    /// </summary>
    var me = this;

    try {
        if (me.error) {
            return false;
        }
        id = parseInt(id, 10);

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'type': 2, 'Itemid': id }),
       function (result) {
          
           if (result === null) { me.showMessage(me.resources.err_saveData, true); return false; }
           if (result === false) { me.showMessage(me.resources.err_savedData, true); return false; }
           me.showBillItems(me.visual.find("#divBillList .vc-list-item.active"));
           return true;
       });

        return true;
    } catch (ex) { me.writeError('delBillItem', ex); return false }

}

Bill.prototype.doEvent = function (event) {
    /// <summary>
    /// Not needed here right now ...
    /// </summary>
    var me = this;
    try {
        switch (event.msg) {
            /// refreshes the bill list after saving the bill vcForm
            case 'BILL_UPDATED':
                me.getBills(); break;
            case 'BILLITEM_UPDATED': /// refreshes the bill item list after saving the bill item vcForm
                me.showBillItems(me.visual.find("#divBillList .vc-list-item.active")); break;
            default: break;
        }
    } catch (ex) { writeError('doEvent', ex); }
};

Bill.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find("#divBillList, #divItemList, #divEdit").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};






function PriceList() {
    /// <summary>
    /// This object provides js functions for the Widget.Meta.Price.List.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 8.9.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 16.11.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.mtid = -1;
}

PriceList.prototype = new vcTemplate();

PriceList.prototype.init = function () {
    /// <summary>
    /// This function inits the click handler. 
    /// </summary>
    var me = this;

    try {
        if (me.error) {
            return false;
        }

        //init the process wizard at the top
        me.visual.find("#divWizard").vcWizard();

       //init the close button
        me.visual.find("#btnClose").off("click").on("click", function () {
            me.toggleFieldsets(false);
            me.visual.find("#divWizard").vcWizard("setActive", 0);
        }).button();

        //init the change event of the year dropdown
        me.visual.find("#ddlYear").off("change").on("change", function () {
            me.mtid = -1;
            me.reload();
            me.visual.find("#divWizard").vcWizard("setActive", 0);
        });
     
        //reset the width of the price edit div
        me.visual.find("#divPriceEdit1").width(me.width - me.visual.find("#divFrameEdit fieldset").width() - 80);

        //click handler of one single month entry
        me.visual.find("#divFrameEdit").off("click", "li").on("click", "li", function () {
            me.openEditForm($(this));
        });

        return true;
    } catch (ex) { me.writeError('init', ex); return false }

}

PriceList.prototype.openEditForm = function (obj) {
    /// <summary>
    /// This form opens the edit form for the given month and meta type
    /// </summary>
    var me = this;
    try {
        //set the clicked line as active
        me.visual.find("#divFrameEdit li").removeClass("active ");
        obj.addClass("active");

        me.mtid = parseInt(obj.data("id"), 10);
        //hide all other fieldsets except the current one
        me.toggleFieldsets(true);

        //make progress in the wizard ;-)
        me.visual.find("#divWizard").vcWizard("setActive", 1);

        //if the meta type is based on a rule - show the rule info
        //otherwise open the calculation edit form
        if (obj.data("hasrule") === true) {
            me.showRule();
        } else {
            me.vcVisual.addVisualContentByName('divPrice', 'VISUAL_META_PRICE_EDIT', 'Edit1', getCurrentTimestamp(), parseInt(me.visual.find("#divPriceEdit1").height(), 10), parseInt(me.visual.find("#divPriceEdit1").width(), 10), JSON.stringify({ "mtid": me.mtid, "year": parseInt(obj.data("year"), 10), "Month": parseInt(obj.data("index"), 10) }), '', 1);
        }

    } catch (ex) { writeError('openEditForm', ex); }
};

PriceList.prototype.toggleFieldsets = function (bShow) {
    /// <summary>
    /// This function either shows all meta type lists or hides all except the current one
    /// </summary>
    var me = this;
    try {

        if (bShow) {
            me.visual.find("fieldset[data-id!=" + me.mtid + "]").hide();
            me.visual.find("#divPrice").show();
        } else {
            me.mtid = -1;
            me.visual.find("#divPrice").hide();
            me.visual.find("fieldset li").removeClass("active");
            me.visual.find("fieldset").show();
            me.visual.find("#divPriceEdit1").html("");
        }

    } catch (ex) { writeError('toggleFieldsets', ex); }
};


PriceList.prototype.reload = function () {
    /// <summary>
    /// Reloads all meta type lists
    /// </summary>
    var me = this;
    try {
        //start over again in the wizard
        me.visual.find("#divWizard").vcWizard("setActive", 0);

        var year = me.visual.find('#ddlYear').val();
        window.VisualCoreService.getData(me.vcvid, me.vcgid, '1.1.' + year, 0, 0, '', '', me.deviceType, 2, JSON.stringify({ 'type': 1, "year": me.year }),
        function (result) {

            if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }
            if (result === "") { me.showMessage(me.resources.err_loadData, true); return false; }
            me.visual.find('#divFrameEdit').html(result);
            //if a meta type is currently selected - hide all other meta type lists again
            if (me.mtid > 0) {
                me.toggleFieldsets(true);
            } else {
                me.toggleFieldsets(false);
            }

            return true;
        });
        return true;
    } catch (ex) { writeError('reload', ex); return false;}
};


PriceList.prototype.showRule = function () {
    /// <summary>
    /// Generates a simple information for the meta rule.
    /// </summary>
    var me = this;
    try {

        me.visual.find("#divWizard").vcWizard("setActive", 0);
        me.visual.find("#divPriceEdit1").html(me.vcC.getLoadingIcon());
        var year = me.visual.find('#ddlYear').val();
        window.VisualCoreService.getData(me.vcvid, me.vcgid, '1.1.' + year, 0, 0, '', '', me.deviceType, 2, JSON.stringify({ 'type': 2, "mtid": me.mtid }),
        function (result) {
            if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }
            if (result === "") { me.showMessage(me.resources.err_loadData, true); return false; }
            me.visual.find('#divPriceEdit1').html(result);

            return true;
        });
        return true;
    } catch (ex) { writeError('showRule', ex); return false}
};


PriceList.prototype.doEvent = function (event) {
    /// <summary>
    /// Handles the _VCMQ-events
    /// </summary>
    var me = this;
    try {
        switch (event.msg) {
            /// refreshes the bill list after saving the bill vcForm
            case 'BILL_SAVED': me.reload(); me.visual.find("#divWizard").vcWizard("setActive", 2);
                break; //reset the wizard step 
            case 'BILL_TEMPLATE_CHANGED': me.visual.find("#divWizard").vcWizard("setActive", 1);
                break;
            default: break;
        }
    } catch (ex) { writeError('doEvent', ex); }
};


PriceList.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find("fieldset, #divEditPrice1").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};










function PriceEdit() {
    /// <summary>
    /// This object provides js functions for the Widget.Meta.Price.Edit.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 8.9.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 16.11.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

    this.mbid = -1;
    this.billList = null;
    this.incomplete = false; //is true of any signal in the bill item list is invalid, missing or inplausible
    this.price = 0;
}

PriceEdit.prototype = new vcTemplate();

PriceEdit.prototype.init = function () {
    /// <summary>
    /// This function inits the click handler. 
    /// </summary>
    var me = this;

    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
      
        //show items for selected bill
        me.visual.find("#divBillList").off("click", ".vc-list-item").on("click", ".vc-list-item", function() {
            me.showBillItems($(this));
            window._VCMQ.produce(me.visual, me.vcgid, 'BILL_TEMPLATE_CHANGED');
        });
       
        //init the click handler of the save button
        me.visual.find("#divBtnSave").off("click").on("click", function() {
            if (me.incomplete) {
                me.saveBillDialog();
            } else {
                me.savePrice();
            }
            
        }).button();

        //init the del button
        me.visual.find("#divBtnDel").off("click").on("click", function () {
            me.delBillDialog();
        }).button();

        //reset the width of the item list (right)
        me.visual.find("#divItemList").width(parseInt(me.visual.width() - me.visual.find("#divBillList").width(), 10) - 15);

        //show initial bill list
        if (me.visual.find("#divBillList .vc-list-item.active").length === 1) {
            me.showBillItems(me.visual.find("#divBillList .vc-list-item.active"));
        }

        return true;
    } catch (ex) { me.writeError('init', ex); return false }

}


PriceEdit.prototype.saveBillDialog = function () {
    /// <summary>
    /// This function opens a modal dialog for saving a price with invalid energy data.<br/>
    /// </summary>
    var me = this;
    try {
        return me.dialog(me.resources.shouldPriceGetSavedAlthoughIncomplete, "BILL_SAVE_PRICE");

    } catch (ex) { me.writeError('saveBillDialog', ex); return false; }
};


PriceEdit.prototype.delBillDialog = function () {
    /// <summary>
    /// This function opens a modal dialog for deleting an existing price.<br/>
    /// </summary>
    var me = this;
    try {
        return me.dialog(me.resources.shouldPriceGetDeleted, "BILL_DEL_PRICE");

    } catch (ex) { me.writeError('delBillDialog', ex); return false; }
};


PriceEdit.prototype.dialog = function (caption, event) {
    /// <summary>
    /// This function opens a modal dialog for deleting bills and bill items.<br/>
    /// </summary>
    var me = this;
    try {
        var dialog = $('<p>' + caption + '</p>').dialog({
            title: me.resources.dialogTitle, modal: true,
            buttons: {
                "Yes": function () {
                    window._VCMQ.produce(me.visual, me.vcgid, event);
                    dialog.dialog('close');
                },
                "Cancel": function () { dialog.dialog('close'); return false; }
            },
            dialogClass: 'saveDialog'
        });
        // ReSharper disable InvalidValue
        $('.saveDialog .ui-button-text:contains(YES)').text(me.resources.yes);
        $('.saveDialog .ui-button-text:contains(CANCEL)').text(me.resources.cancel);
        // ReSharper restore InvalidValue
        return false;
    } catch (ex) { me.writeError('saveBillDialog', ex); return false; }
};


PriceEdit.prototype.savePrice = function () {
    return this.manipulatePrice(1);
}

PriceEdit.prototype.delPrice = function () {
    return this.manipulatePrice(2);
}


PriceEdit.prototype.manipulatePrice = function (type) {
    /// <summary>
    ///  This function updates or deletes a price
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'type': type, 'price': me.price, 'mtid': me.mtid, "year": me.year, "Month": me.month }),
       function (result) {

           if (result === null) { me.showMessage(me.resources.err_saveData, true); return false; }
           if (result.Data === null) { me.showMessage(me.resources.err_saveData, true); return false; }

           window._VCMQ.produce(me.visual, me.vcgid, 'BILL_SAVED');

           return true;
       });

        return true;
    } catch (ex) { me.writeError('manipulatePrice', ex); return false }
}

PriceEdit.prototype.showBillItems = function (obj) {
    /// <summary>
    ///  This function shows a list of bill items based on the given meta bill
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        //set the given bill template as 
        me.visual.find("#divBillList .vc-list-item").removeClass("active");
        obj.addClass("active");

        me.visual.find("#divSum").hide(0);
        me.visual.find("#divItemList").show();

        me.mbid = parseInt(obj.data("id"), 10);

        me.visual.find("#divItemList .entries").html(me.vcC.getLoadingIcon());
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'type': 2,'mbid': me.mbid , "year":me.year, "Month":me.month}),
       function (result) {
       
           if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }
           if (result.Data === null) { me.showMessage(me.resources.err_loadData, true); return false; }

           if (result.Data.rows === null) {
               me.visual.find("#divItemList .entries").html("<div class='note'>" + me.resources.noEntriesExist + "</div>");
               return true;
           }
          
           if (result.Data.rows.length === 0) {
               me.visual.find("#divItemList .entries").html("<div class='note'>" + me.resources.noEntriesExist + "</div>");
               return true;
           }
          
           //add the bill items
           me.generateItemList(result);

           return true;
       });

        return true;
    } catch (ex) { me.writeError('showBillItems', ex); return false }
}





PriceEdit.prototype.generateItemList = function (result) {
    /// <summary>
    ///  This function generates the html for the bill list based on the received data table. <br/>
    /// Based on the given item types and price units the costs get calculated. 
    /// </summary>
    var me = this;
    var sTmp = "";
    var sTmpInfo = "";
    var i;
    var dVal = 0;
    var dValSum = 0;
    var items;
    var incomplete = false;
    try {
        if (me.error) {
            return "";
        }
      
        items = result.Data;
        sTmp += "<div class='list'>";
        for (i = 0; i <= items.rows.length - 1; i++) {
            sTmp += "<div data-id='" +items.rows[i].id +"' data-type='" +items.rows[i].itemtypeid + "' class='vc-list-item tblBody";
            //add an error style if data is invalid
            if (items.rows[i].invalid || items.rows[i].inplausible || items.rows[i].missing) { sTmp += " err" }
            sTmp += "'>";
            sTmp += "<div  class='col col1'><u>" + items.rows[i].itemtype + "</u><br/>" + items.rows[i].name + "</div>";
            sTmp += "<div class='col col2'>";
            if (items.rows[i].signal !== null) {

                if (items.rows[i].invalid) {sTmp += me.iconInvalid; incomplete=true}
                if (items.rows[i].inplausible) { sTmp += me.iconInplausible; incomplete = true }
                if (items.rows[i].missing) { sTmp += me.iconMissing; incomplete = true }

                sTmp += items.rows[i].signal;
            } else {
                sTmp += "<br/>";
            }
            sTmp += "</div>";
            sTmp += "<div class='col col3'>" + Highcharts.numberFormat(items.rows[i].price, me.digits, ',', '.') + " * " + items.rows[i].factor + "</div>";
            sTmp += "<div class='col col4'>" + items.rows[i].unit + "</div>";

            switch (items.rows[i].itemtypeid) {
                case 1: //consumption
                    if (items.rows[i].unitid === 1) {
                        sTmpInfo = Highcharts.numberFormat(items.rows[i].value, 2, ',', '.') + "*" + Highcharts.numberFormat(items.rows[i].price / 100, me.digits, ',', '.') + "*" + items.rows[i].factor;
                        dVal = (items.rows[i].price * items.rows[i].factor * items.rows[i].value / 100);
                    }
                   
                    break;
                case 2: //power
                    if (items.rows[i].unitid > 1) {
                        sTmpInfo = "";
                        dVal = 0;
                        if (items.rows[i].unitid === 2) {
                            sTmpInfo = Highcharts.numberFormat(items.rows[i].value, 2, ',', '.') + "*(" + Highcharts.numberFormat(items.rows[i].price, me.digits, ',', '.') + "*" + items.rows[i].factor + "/12)";
                            dVal = (items.rows[i].value * items.rows[i].price * items.rows[i].factor / 12);
                        }
                        if (items.rows[i].unitid === 3) {
                            sTmpInfo = Highcharts.numberFormat(items.rows[i].value, 2, ',', '.') + "*(" + Highcharts.numberFormat(items.rows[i].price, me.digits, ',', '.') + "*" + items.rows[i].factor + "/" + me.yearDays + "*" + me.monthDays + ")";
                            dVal = (items.rows[i].value * items.rows[i].price * items.rows[i].factor / me.yearDays * me.monthDays);
                        }
                    } 
                    break;
                case 3: //charges
                    if (items.rows[i].unitid > 1) {
                        if (items.rows[i].unitid === 2) {
                            sTmpInfo = Highcharts.numberFormat(items.rows[i].price, me.digits, ',', '.') + "*" + items.rows[i].factor + "/12)";
                            dVal = (items.rows[i].price * items.rows[i].factor / 12);
                        }
                        if (items.rows[i].unitid === 3) {
                            sTmpInfo = Highcharts.numberFormat(items.rows[i].price, me.digits, ',', '.') + "*" + items.rows[i].factor + "/" + me.yearDays + "*" + me.monthDays + ")";
                            dVal = (items.rows[i].price * items.rows[i].factor / me.yearDays * me.monthDays);
                        }
                    }
                    break;
                default:
                    sTmpInfo = "0";
                    dVal = 0;
                    break;
            }

            dValSum += dVal;
            sTmp += "<div class='col col5'>" + sTmpInfo + "</div>";
            sTmp += "<div class='col col6'>" + dVal + "</div>";

            sTmp += "</div>";
            sTmp += "<div style='clear:both'></div>";
         
        }
        sTmp += "</div>"; //end list
        //set the unit of the bill template signal into the calculation div
        me.visual.find("#divSum .unit").html(me.visual.find("#divBillList .vc-list-item.active").data("unit"));

        me.visual.find(".billListValidation span").html("");
        //add error icons if the monthly sum is invalid
        if (result.MonthlySumInvalid) {
            me.visual.find(".billListValidation[data-id=" + me.mbid + "] span").append(me.iconInvalid);
            incomplete = true;
        }
        if (result.MonthlySumInplausible) {
            me.visual.find(".billListValidation[data-id=" + me.mbid + "] span").append(me.iconInplausible);
            incomplete = true;
        }

        if (result.MonthlySumMissing) {
            me.visual.find(".billListValidation[data-id=" + me.mbid + "] span").append(me.iconMissing);
            incomplete = true;
        }

        me.incomplete = incomplete;
        //show/hide error infos on incomplete data or wrong bill template date
        if (me.incomplete) {
            me.visual.find("#divIncomplete").show();
        } else {
            me.visual.find("#divIncomplete").hide();
        }

        if (me.mbid === me.mbidStart) {
            me.visual.find("#divWrongTemplate").hide();
            me.visual.find("#divBtnSave").show();
        } else {
            me.visual.find("#divWrongTemplate").show();
            me.visual.find("#divBtnSave").hide();
            me.incomplete = true;
        }
        if (me.incomplete) {
            me.visual.find("#divSum").addClass("error");
        } else {
            me.visual.find("#divSum").removeClass("error");
        }

        //calculate the price
        //it's the sum of all bill items / monthly sum of bill template signal
        me.price = 0;
        if (result.MonthlySum !== 0) {
            me.price = dValSum / result.MonthlySum;
        }

        me.visual.find(".priceSum.values").html(dValSum);
        me.visual.find(".energySum.values").html(result.MonthlySum);
        me.visual.find(".price.values").html(me.price);

        me.visual.find("#divSum").show();

        me.visual.find("#divItemList .entries").html(sTmp);

        //adopt the height of the bill item list 
        var heightDif = parseInt(me.visual.find("#divItemList").height(), 10) -
            parseInt(me.visual.find("#divItemList .header").height(), 10) -
            parseInt(me.visual.find("#divItemList .tblHeader").height(), 10) -
            parseInt(me.visual.find("#divSum").height(), 10) -
            100;
        if (heightDif < parseInt(me.visual.find("#divItemList .entries").height(), 10)) {
            me.visual.find("#divItemList .entries").height(heightDif);
            me.visual.find("#divItemList .entries").css("overflow", "auto");
        } else {
            me.visual.find("#divItemList .entries").css("height","");
        }

        me.visual.find("#divItemList .col6, #divItemList .values").formatDouble(me.digits);
        me.visual.find("#divItemList .vc-list-item").filter(":even").addClass("alt");

        return sTmp;
    } catch (ex) { me.writeError('generateItemList', ex); return "" }

}


PriceEdit.prototype.doEvent = function (event) {
    /// <summary>
    /// Handle the VCMQ-events
    /// </summary>
    var me = this;
    try {
        switch (event.msg) {
            //
            case 'BILL_SAVE_PRICE':
                me.savePrice(); break;
            case 'BILL_DEL_PRICE': 
                me.delPrice(); break;
        }
    } catch (ex) { writeError('doEvent', ex); }
};


PriceEdit.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find("#divBillList, #divItemList, #divEdit").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};

